import * as Yup from 'yup'

export default Yup.object().shape({
    action: Yup.string().required('Ação é obrigatória!'),
    operator: Yup.string().required('Consumo é obrigatório!'),
    percentage: Yup.string().when('$hidePercentageField',
        (hidePercentageField) => {
            if (hidePercentageField[0])
                return Yup.string()
            return Yup.number().typeError('Percentual é obrigatório!').required('Percentual é obrigatório!')
            
        }),
    minValue: Yup.string().when(['$hideMinField'],
        (hideMinField) => {
            if (hideMinField[0])
                return Yup.string()
            return Yup.number().typeError('Valor mínimo é obrigatório!').required('Valor mínimo é obrigatório!')
            
        }),
    maxValue: Yup.string().when('$hideMaxField',
        (hideMaxField) => {
            if (hideMaxField[0])
                return Yup.string()
            return Yup.number().typeError('Valor máximo é obrigatório!').required('Valor máximo é obrigatório!')
                .test('is-after-minValue', 'Máximo deve ser maior que mínimo!', function (maxValue) {
                    const { minValue } = this.parent
                    return maxValue > minValue
                })
        }),
    color: Yup.string().required('Cor é obrigatório!')
})